import React, { useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

import useStateSearch from '../../../../../../hooks/useStateSearch';

export default function StateField({ state = '', onChangeState }) {
  const {states, isLoading} = useStateSearch();

  const mappedStatesUF = states.map(state => state?.uf);

  const [search, setSearch] = useState('');
  
  return (
    <Autocomplete
      clearOnEscape
      selectOnFocus
      handleHomeEndKeys
      options={mappedStatesUF}
      loading={isLoading}
      value={state}
      inputValue={search}
      noOptionsText="Nenhum estado encontrado"
      onInputChange={(event, newValue) => setSearch(newValue)}
      onChange={(event, newValue) => onChangeState(newValue)}
      getOptionSelected={(option, value) => option === value}
      getOptionLabel={state => state ? `${state}` : ''}
      renderInput={(params) => (
        <TextField {...params} label="Estado" />
      )}
    />
  );
}